import React from "react"
import { LayoutCards } from "trimble-terra"
import { Link } from "gatsby"
import formatPageLinks from "../formatPageLinks"
import { formatCommonComponentFields } from "./formatLayoutFunctions";
import RichTextConnector from "../../../components/RichText/RichTextConnector"
import { formatThemePreset } from "../formatTheme"
import { formatFocusedImage } from "../formatBaseMolecules";

const iconMap = {
  'Blog': 't2u-paste',
  'Case Study': 't2u-casestudy',
  "Whitepaper": 't2u-whitepaper', 
  "Video": 't2u-videocam', 
  "Podcast": 't2u-podcasts',
}
  
const FormatAndRenderLayoutCaseStudies = ({
  data, 
  cardType, 
  locale, 
  siteIdentifier, 
  homepageSlug, 
  currentSpaceId,
  passthroughProps,
}) => {
  // For personalization variants, use passthroughProps; otherwise use props from baseline
  const activeLocale = passthroughProps?.locale || locale
  const activeSiteIdentifier = passthroughProps?.siteIdentifier || siteIdentifier
  const activeHomepageSlug = passthroughProps?.homepageSlug || homepageSlug
  const activeCurrentSpaceId = passthroughProps?.currentSpaceId || currentSpaceId
  const activeCardType = passthroughProps?.cardType || cardType

  const formattedComponentData = formatCommonComponentFields(data, activeLocale, activeSiteIdentifier, activeHomepageSlug, activeCurrentSpaceId);
  formattedComponentData.cardType = activeCardType || "bound"
  formattedComponentData.isButtonTopAligned = data?.buttonPlacement || false
  formattedComponentData.cards = data.cards?.map((card) => {
    const formattedLink = formatPageLinks(card?.link, activeLocale, activeSiteIdentifier, activeHomepageSlug, activeCurrentSpaceId)
    const button = card?.link ? { primary: card?.link?.isPrimary, label: formattedLink?.text, destination: formattedLink?.url, } : null
    const description = card?.description 
      ? <RichTextConnector data={{ content: card?.description }} includeClasses={false} /> 
      : null
    return {
      eyebrow: card?.category || card?.eyebrow,
      eyebrowIcon: card?.category ? iconMap[card?.category] : null,
      header: card?.header,
      description: description,
      button: button,
      image: card?.image ? formatFocusedImage(card?.image) : null,
      imageType: "asImage",
    }
  })

  return (
    <LayoutCards
      {...formattedComponentData}
      isWrapped={true}
    />
  )
}

export default FormatAndRenderLayoutCaseStudies
